/* ════ FILTER MATCHER (pure) ═══════════════════════════════ */
import { state } from './state.js';
import { catLabel } from './categories.js';

export function matchFilter(t) {
  const f = state.filters;
  if (f.cat !== 'all' && t.cat !== f.cat) return false;
  if (f.resource !== 'all' && t.resource !== f.resource) return false;
  if (f.role && f.role !== 'all') {
    const r = state.resources.find(x => x.id === t.resource);
    if ((r?.role || '') !== f.role) return false;
  }
  if (f.client && f.client !== 'all' && (t.client || '') !== f.client) return false;
  if (f.team && f.team !== 'all' && (t.team || '') !== f.team) return false;
  if (f.hideDone && t.completed) return false;
  if (f.invoicing && f.invoicing !== 'all') {
    if (f.invoicing === 'invoiced' && !t.invoiced) return false;
    if (f.invoicing === 'toinvoice' && t.invoiced) return false;          // anything not yet invoiced
    if (f.invoicing === 'ready' && !(t.ready_invoice && !t.invoiced)) return false;
  }
  if (f.importance !== 'all' && (t.importance || 'normal') !== f.importance) return false;
  if (f.text) {
    const q = f.text.toLowerCase();
    // Search across the whole card, not just the title.
    const r = state.resources.find(x => x.id === t.resource);
    const subtasks = (t.subtasks || []).map(s => s.text).join(' ');
    const hay = [
      t.name, t.client, t.team, t.job, t.designer, t.consultant, t.info, t.link,
      t.importance, t.cat, catLabel(t.cat), r?.name, r?.role, t.created_by,
      (t.tags || []).join(' '), subtasks,
    ].filter(Boolean).join(' ').toLowerCase();
    if (!hay.includes(q)) return false;
  }
  return true;
}
